import React from 'react';
import { Accordion, AccordionItem, AccordionPanel, AccordionTrigger, Heading } from '@web-for-marketing/react-ui';
import { RichTextContent } from '@components/RichTextContent';
import { breakpoints } from '@web-for-marketing/react-ui';
import { ArticleFAQType } from '@models/article';

interface ArticleFAQAccordionListProps {
    lists: ArticleFAQType[];
    title: string;
    className?: string;
}

const classes = {
    title: {
        marginBottom: '3.2rem',
        [`@media (max-width: ${breakpoints.sm})`]: {
            marginBottom: '1.6rem',
        },
    },
    accordion: {
        display: 'flex',
        flexDirection: 'column',
        gap: '4px',
    },
} as const;

export function ArticleFAQAccordionList({ lists, title, className }: ArticleFAQAccordionListProps): React.ReactElement {
    return (
        <div className={className}>
            {title ? (
                <Heading variant='h3' css={classes.title}>
                    {title}
                </Heading>
            ) : null}
            <Accordion css={classes.accordion}>
                {lists.map(({ question, answer }) => (
                    <AccordionItem key={question}>
                        <AccordionTrigger headingLevel='h4'>{question}</AccordionTrigger>
                        <AccordionPanel>
                            <RichTextContent content={answer} />
                        </AccordionPanel>
                    </AccordionItem>
                ))}
            </Accordion>
        </div>
    );
}
